export default "__VITE_ASSET__DN_YIq4N__"